import React from "react";
import { MultiDropdownItemProps } from "./types";

const DropdownItem: React.FC<MultiDropdownItemProps> = (
  props: MultiDropdownItemProps
) => {
  const { value, text, image, onClick } = props;

  return (
    <>
      <li
        className="text-[#344054] relative cursor-default select-none py-2.5 pl-3 pr-9 border-t border-[#EAECF0] mt-[-1px] hover:bg-blue-600 hover:cursor-pointer hover:text-white "
        id="listbox-option-0"
        role="option"
        aria-selected={false}
        onClick={(e) => onClick(e, value)}
        value={value}
      >
        <div className="flex items-center">
          {image && (
            <img
              src={image}
              alt=""
              className="h-5 w-5 flex-shrink-0 rounded-full"
            />
          )}
          <span className="font-normal  block truncate">{text}</span>
        </div>
      </li>
    </>
  );
};

export default React.memo(DropdownItem);
